/**
 * 示例-详情页
 * luxinwen
 * 2023-01
 */
<template>
  <div class="page">
    <div class="page-main">
      <div class="page-main-content">
        <div class="page-main-content-thead">详情页示例</div>
        <div class="flex-list">
          <div class="flex-list-item" v-for="(item, index) in list" :key="'item' + index" @click="showDetail(item.subTitle)">
            <p>{{ item.title }}</p>
            <span>{{ item.subTitle }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        list: [
          {
            title: '普通详情页',
            subTitle: 'Default'
          }
        ]
      };
    },
    methods: {
      /**
       * 查看详情
       */
      showDetail(type) {
        this.$router.push({
          name: 'testDetail' + type
        });
      }
    }
  };
</script>